const submitForm = document.getElementById("custom-inquiry-form");

function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      resolve(e.target.result);
    };

    reader.onerror = function (e) {
      console.log(e);
      reject(e);
    };

    reader.readAsDataURL(file);
  });
}

function convertAVIFToJPEG(avifDataUrl) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const img = new Image();
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;

      context.drawImage(img, 0, 0, img.width, img.height);

      const jpegDataUrl = canvas.toDataURL("image/jpeg");
      resolve(jpegDataUrl);
    };

    img.src = avifDataUrl;
  });
}

submitForm.addEventListener("submit", async function (e) {
  e.preventDefault();

  console.log(this);
  const host = "https://op-backend-6d3fcaacf893.herokuapp.com";

  const name = document.querySelector("#full-name").value;
  const email = document.querySelector("#email").value;
  const deadline = document.querySelector("#deadline-selection").value;
  const date = document.querySelector("#date").value;
  const message = document.querySelector("#textarea").value;
  const quantity = document.querySelector("#quantity").value;
  const productType = document.querySelector("#product_type").value;

  const successEl = document.querySelector("#success");
  const errorEl = document.querySelector("#error");
  const loadingEl = document.querySelector(".loading-overlay__spinner");

  /*
    text: Name of customer
    email: Email of customer. Preferrably set both child keys to be same value.
    status8: Type of Product. 1 is Pennant. 2 is Camp Flag. 3 is Banner. 4 is Unsure
    long_text: Description about product
    status_1: Hard deadline? Set index to 1 for No, 2 for Yes
    date4: Date for project. Set in YYYY-MM-DD
    color: Project Type. 0 for Custom Bulk and 9 for Custom One-off
  */

  let form = {
    text: name,
    email: {
      text: email,
      email: email,
    },
    status8: {
      ids: [parseInt(productType)],
    },
    long_text: message,
    status_1: {
      index: deadline,
    },
    date4: {
      date: date,
    },
    color: quantity,
  };

  if (!form.status_1.index) {
    delete form.status_1;
  } else {
    form.status_1.index = parseInt(form.status_1.index);
  }

  if (!form.date4.date) {
    delete form.date4;
  }

  if (!form.color) {
    delete form.color;
  }

  form.long_text = form.long_text
    .split(/[\r\n]/)
    .join(" ")
    .replace(/"/g, "'");

  const files = document.querySelector("#select-file").files ?? [];
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (files.length > 0 && !files[0].type.includes("image") && !files[0].name.includes(".heic")) {
    alert("Invalid file");
    return;
  }

  let fileToUpload = files[0];

  if (files[0]?.name.includes(".heic")) {
    let blobURL = URL.createObjectURL(files[0]);

    let blobRes = await fetch(blobURL);

    let blob = await blobRes.blob();

    let conversionResult = await heic2any({ blob, toType: "image/jpeg" });
    const fileName = files[0].name;
    fileToUpload = new File([conversionResult], `test.${fileName.split(".").pop()}`);
  }

  if (files[0]?.name.includes(".avif")) {
    try {
      const avifDataUrl = await readFileAsDataURL(files[0]);
      const jpegDataUrl = await convertAVIFToJPEG(avifDataUrl);
      let blobRes = await fetch(jpegDataUrl);

      let blob = await blobRes.blob();

      const fileName = files[0].name;
      fileToUpload = new File([blob], `test.${fileName.split(".").pop()}`);
    } catch (error) {
      console.log(error);
    }
  }

  const fetchOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(form),
    redirect: "follow",
  };

  const handleFileUpload = async (id, originalFile) => {
    try {
      let file = originalFile;

      let maxSize = 200;

      if (originalFile.size / 1000 < 200) {
        maxSize = Math.ceil(originalFile.size / 2000);
      }
      
      if (originalFile.size / 1000 >= maxSize) {
        let low = 0.0;
        let middle = 0.5;
        let high = 1.0;

        let dataUrl = new FileReader();
        await dataUrl.readAsDataURL(originalFile);
        let result;

        await dataUrl.addEventListener(
          "load",
          async () => {
            // convert image file to base64 string
            dataUrl = dataUrl.result;
            while (Math.abs(file.size / 1000 - maxSize) > 50) {
              console.log(originalFile)
              const canvas = document.createElement("canvas");
              const context = canvas.getContext("2d");
              const img = document.createElement("img");

              const promise = new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = reject;
              });

              img.src = dataUrl;

              await promise;

              canvas.width = Math.round(img.width * middle);
              canvas.height = Math.round(img.height * middle);
              context.scale(canvas.width / img.width, canvas.height / img.height);
              context.drawImage(img, 0, 0);
              const name = `test.${originalFile.name.split(".").pop()}`;
              file = await urltoFile(canvas.toDataURL(), name, originalFile.type);

              if (file.size / 1000 < maxSize - 50) {
                low = middle;
              } else if (file.size / 1000 > maxSize) {
                high = middle;
              }

              middle = (low + high) / 2;
              result = canvas.toDataURL();
            }

            if(!result){
              result = dataUrl
            }

            const name = `test.${originalFile.name.split(".").pop()}`
            file = await urltoFile(result, name, originalFile.type);
            await uploadFileToServer(id, file);
          },
          false
        );
      } else {
        await uploadFileToServer(id, file);
      }
    } catch (error) {
      throw Error();
    }
  };

  function urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  const uploadFileToServer = async (id, file) => {
    const formData = new FormData();
    formData.append("file", file);

    // We upload to monday function, sending file and the id of the item where we want the files to be uploaded
    const response = await fetch(`${host}/mondayFile?id=${id}`, {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      showError();
    } else {
      showSuccess();
    }
  };

  const showSuccess = () => {
    loadingEl.classList.add("hidden");
    this.classList.add("hidden");
    successEl.classList.remove("hidden");
    scrollToMessage();
  };

  const showError = () => {
    loadingEl.classList.add("hidden");
    this.classList.add("hidden");
    errorEl.classList.remove("hidden");
    scrollToMessage();
  };

  const showLoading = () => {
    this.classList.add("hidden");
    loadingEl.classList.remove("hidden");
    scrollToMessage();
  };

  const scrollToMessage = () => {
    const states = document.querySelector(".states");
    states.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  try {
    console.log("asadsadassa");
    showLoading();
    const response = await fetch(`${host}/monday`, fetchOptions);
    if (response.ok) {
      const body = await response.json();
      // Successful upload
      if (body.data) {
        const id = body.data.create_item.id;
        //Upload images
        console.log(files);
        console.log(files.length);
        if (files.length > 0) {
          await handleFileUpload(id, fileToUpload);
        } else {
          showSuccess();
        }
      }
    } else {
      throw Error();
    }
  } catch (err) {
    showError();
  }
});
